import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import EditSvg from 'images/v5/icons/edit-02.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { Cell, Row } from 'layout/atoms/TableGrid';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'molecules/Grid/Grid';
import { openModal } from 'store/layoutSlice';
import { fetchBrands, removeBrand, selectBrands, selectBrandsErrors, selectBrandsPageInfo, selectBrandsRefetchFlags, selectBrandsStatus, } from 'store/parameters/brandsSlice';
import ParametersTable from '../shared/ParametersTable';
function Brands() {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const brands = useSelector(selectBrands);
    const pageInfo = useSelector(selectBrandsPageInfo);
    const status = useSelector(selectBrandsStatus);
    const errors = useSelector(selectBrandsErrors);
    const refetchFlags = useSelector(selectBrandsRefetchFlags);
    const fetchMore = () => {
        if (pageInfo.hasNextPage && status.fetch !== 'loading') {
            dispatch(fetchBrands());
        }
    };
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(fetchBrands());
        }
    }, [dispatch, status.fetch, refetchFlags.fetch]);
    const handleDelete = (brandId) => {
        dispatch(removeBrand(brandId));
    };
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("div", null, errors.fetch);
    }
    const hasBrands = brands.length > 0;
    return (React.createElement(Grid, { gap: 24 },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' } },
            React.createElement(Button, { color: "primary", onClick: () => dispatch(openModal({ name: 'brandCreator' })) }, t('add_brand'))),
        hasBrands ? (React.createElement(ParametersTable, { columns: [
                ['320px', '1fr'],
                ['72px', 'auto'],
            ], headers: [{ content: t('common:name') }, { content: null }], dataLength: brands.length, hasMore: pageInfo.hasNextPage, fetchMore: fetchMore }, brands.map((brand) => (React.createElement(Row, { key: brand.id },
            React.createElement(Cell, null, brand.name),
            React.createElement(Cell, null, ((brand === null || brand === void 0 ? void 0 : brand.canNameBeUpdated) || (brand === null || brand === void 0 ? void 0 : brand.canBeRemoved)) && (React.createElement(Dropdown, null,
                (brand === null || brand === void 0 ? void 0 : brand.canNameBeUpdated) && (React.createElement(Button, { align: "left", theme: "ghost", leftIcon: React.createElement(EditSvg, null), onClick: () => dispatch(openModal({ name: 'brandEditor', id: brand.id })) }, t('common:edit'))),
                (brand === null || brand === void 0 ? void 0 : brand.canBeRemoved) && (React.createElement(Button, { align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: () => handleDelete(brand.id) }, t('common:delete'))))))))))) : (React.createElement(EmptyState, null))));
}
export default memo(Brands);
